import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useShare } from '../context/ShareContext';
import { engagementService } from '../services/engagementService';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const MenuItemLikeButton = ({
  offerId,
  itemIndex,
  count = 0,
  liked = false,
  onChange,
  className = '',
}) => {
  const { user } = useShare();
  const navigate = useNavigate();
  const location = useLocation();
  const [likeCount, setLikeCount] = useState(Number(count || 0));
  const [likedByMe, setLikedByMe] = useState(Boolean(liked));
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => setLikeCount(Number(count || 0)), [count]);
  useEffect(() => setLikedByMe(Boolean(liked)), [liked]);

  const toggleLike = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (!user) {
      navigate('/auth', { state: { from: `${location.pathname}${location.search}` } });
      return;
    }

    if (isSaving) return;
    setIsSaving(true);

    try {
      const result = await engagementService.toggleMenuItemLike(offerId, itemIndex);
      setLikeCount(result.likeCount);
      setLikedByMe(result.likedByMe);
      onChange?.(result);
    } catch (error) {
      console.error('Gericht konnte nicht geliked werden:', error);
      alert('Der Like konnte nicht gespeichert werden.');
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <button
      type="button"
      onClick={toggleLike}
      disabled={isSaving}
      aria-pressed={likedByMe}
      title={likedByMe ? 'Like entfernen' : 'Gericht liken'}
      className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-sm font-bold transition-colors disabled:cursor-wait disabled:opacity-60 ${likedByMe ? 'border-rose-200 bg-rose-50 text-rose-600' : 'border-gray-200 bg-white text-gray-500 hover:border-rose-200 hover:text-rose-600'} ${className}`}
    >
      <SafeIcon icon={FiIcons.FiHeart} className={likedByMe ? 'fill-current' : ''} />
      <span>{likeCount}</span>
    </button>
  );
};

export default MenuItemLikeButton;
